<template>
  <Modal
    :mask-closable="false"
    :closable="false"
    title="批量导入"
    v-model="modal">
    <Form ref="handleForm" :model="handleForm" :rules="handleValidate" :label-width="110">
      <Row>
        <Col :sm="24" :xs="24">
          <FormItem label="1. 选择商户:" prop="agentId">
            <Select
              v-model.trim="handleForm.agentId"
              filterable
              remote
              clearable
              :remote-method="getAgent"
              :loading="agentLoading"
              @on-select="selectAgent"
              @on-query-change="changeAgent">
              <Option v-for="(option, index) in agentList" :value="option.id" :key="index">{{option.agentName}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="1. 选择商品:" prop="commodityId">
            <Select
              v-model.trim="handleForm.commodityId"
              filterable
              remote
              clearable
              :loading="commodityLoading">
              <Option v-for="(option, index) in commodityOptions" :value="option.id" :key="index">{{option.commodityName}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="2. 下载模板:" prop="template">
            <a :href="downloadUrl" class="text-link" target="_blank">点击下载导入模板文件</a>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="3. 上传模板:" prop="file">
            <Upload
              ref="upload"
              :headers="token"
              :data="queryParams"
              :on-success="handleSuccess"
              :on-error="handleError"
              :before-upload="handleBeforeUpload"
              :show-upload-list="false"
              :format="['xlsx']"
              :max-size="5120"
              :on-format-error="handleFormatError"
              :on-exceeded-size="handleMaxSize"
              :action="uploadUrl"
              name="excel">
              <Button icon="md-cloud-upload">选择模板文件</Button>
            </Upload>
            <div v-if="importFile !== null">
              <p>{{ importFile.name }} <Button type="text" @click.native="handleRemove">删除</Button></p>
              <template v-if="uploadingFile && uploadingFile.status === 'uploading'">
                <Progress v-if="uploadingFile.showProgress" :percent="uploadingFile.percentage" :stroke-width="5" hide-info></Progress>
              </template>
            </div>
            <p class="upload-tips">支持的文件格式为：xlsx，小于5M</p>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" @click="hide" :disabled="loading">取消</Button>
      <Button type="primary" :loading="loading" @click="submit">{{ loading ? '批量代理中...' : '批量导入' }}</Button>
    </div>
  </Modal>
</template>

<script>
import api from '../../api'
import { DOWNLOAD_URL } from '../../config/constants'

export default {
  name: 'BatchImport',
  data () {
    const validateUpload = (rule, value, callback) => {
      if (!this.importFile) {
        callback(new Error('请上传模板文件'))
      } else {
        callback()
      }
    }
    return {
      modal: false,
      loading: false,
      commodityLoading: false,
      agentLoading: false,
      commodityOptions: [],
      agentList: [],
      handleForm: {
        agentId: null,
        commodityId: null
      },
      uploadUrl: api.order.carmiBatchImport,
      importFile: null,
      downloadUrl: DOWNLOAD_URL + 'coupon/card.xlsx',
      handleValidate: {
        agentId: [
          { required: true, whitespace: true, message: '请选择导入的商户', trigger: 'change' }
        ],
        commodityId: [
          { required: true, whitespace: true, message: '请选择导入的商品', trigger: 'change' }
        ],
        file: [
          { validator: validateUpload, required: true }
        ]
      },
      selectAgentId: ''
    }
  },
  computed: {
    token () {
      return {
        accessToken: this.$store.state.token
      }
    },
    queryParams () {
      return {
        agentCommodityId: this.handleForm.commodityId
      }
    },
    uploadingFile () {
      return this.$refs.upload.fileList[0]
    }
  },
  methods: {
    show () {
      this.modal = true
    },
    hide () {
      if (this.loading) {
        this.$Modal.warning({
          title: '提示',
          content: '文件正在上传中，请稍等！'
        })
        return
      }
      this.$refs['handleForm'].resetFields()
      this.loading = false
      this.modal = false
      this.handleRemove()
    },
    submit () {
      this.$refs['handleForm'].validate((valid) => {
        if (valid) {
          this.$refs.upload.post(this.importFile)
        } else {
          this.$Message.error('请检查必填项目!')
        }
      })
    },
    handleBeforeUpload (file) {
      this.importFile = file
      this.$refs['handleForm'].validateField('file')
      return false
    },
    handleSuccess (res, file, fileList) {
      if (file.response.code !== '2000') {
        this.$Message.error(file.response.msg || '上传文件错误，请重新上传！')
        this.handleList()
      } else {
        this.handleList()
        this.$Message.success('批量导入完成！')
        this.$emit('success')
        this.hide()
      }
    },
    handleError () {
      this.$Message.error('上传发生错误，请稍后重试！')
      this.handleList()
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: '文件格式错误',
        desc: '文件的格式不正确，请重新选择！'
      })
      this.handleList()
    },
    handleMaxSize (file) {
      this.$Notice.warning({
        title: '文件超过大小限制',
        desc: '文件超过5M大小的限制。'
      })
      this.handleList()
    },
    handleList () {
      this.loading = false
      this.$refs.upload.fileList = []
    },
    handleRemove () {
      this.importFile = null
      this.$refs.upload.fileList = []
    },
    // 选中商户
    selectAgent (val) {
      this.selectAgentId = val.value
      this.getCommodityList(val.value)
      this.handleForm.commodityId = ''
    },
    // 改变商户输入框
    changeAgent (val) {
      this.throttle(this.getAgentList, 500, val)
    },
    // 远程获取商户
    getAgent () {
      this.throttle(this.getAgentList, 500)
    },
    // TODO: 获取商户列表, 需要获取平台自建的代理商，待解决
    getAgentList (val = '') {
      this.agentLoading = true
      api.agent.agentList({
        pageNum: 1,
        pageSize: 100,
        agentName: val
      }).then(res => {
        this.agentLoading = false
        this.agentList = res.data.records
      }).catch(err => {
        this.$Message.error('获取商户列表失败：' + err.message)
      })
    },
    // 改变商品
    // changeCommodity (val) {
    //   this.throttle(this.getCommodityList, 500, val)
    // },
    // 远程获取商品
    // getCommodity () {
    //   this.throttle(this.getCommodityList, 500, this.selectAgentId)
    // },
    // 获取商品
    getCommodityList (val) {
      api.agent.agentCommodityList({
        agentId: val,
        pageNum: 1,
        pageSize: 100
      }).then(res => {
        // TODO：临时解决方案，通过类别名称来过滤代理的商品
        const result = res.data.records || []
        this.commodityOptions = []
        result.forEach(item => {
          item.labelName === '卡密类' && this.commodityOptions.push(item)
        })
      }).catch(err => {
        this.$Message.error('获取商户商品失败：' + err.message)
      })
    },
    throttle (fn, delay, val) {
      clearTimeout(fn.timeoutId)
      fn.timeoutId = setTimeout(function () {
        fn.call(val)
      }, delay)
    }
  },
  mounted () {
    this.changeAgent()
  }
}
</script>
